module.exports = __webpack_public_path__ + "static/img/crest.1c17d46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/crest.png
// module id = lldl
// module chunks = 1